import {Component, Input} from "@angular/core";
import {MatterInvoice, MatterInvoiceStatus} from "../common/matter-invoice";
import {connectApi} from "../common/connect-api";
import {SESSION_STORAGE_KEYS} from "../common/session-storage-keys";

@Component({
  selector: "dp-connect-invoice-list",
  templateUrl: "./invoice-list.component.html",
})
export class InvoiceListComponent {
  @Input() matterInvoices: MatterInvoice[] = [];
  @Input() matterId: number;

  downloadInvoice(matterInvoice: MatterInvoice, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    let baseUrl = window.location.origin;
    let api: string = connectApi.downloadDocument;
    let url =
      baseUrl +
      api
        .replace("{packageGuid}", "" + matterInvoice.packageGuid)
        .replace("{documentId}", "" + matterInvoice.documentId) +
      "?SessionId=" +
      sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId);
    window.open(url, "_blank");
  }

  redirectToPaymentUrl(matterInvoice: MatterInvoice, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    window.open(matterInvoice.paymentUrl);
  }

  mapStatus(matterInvoiceStatus: MatterInvoiceStatus): string {
    switch (matterInvoiceStatus) {
      case MatterInvoiceStatus.complete:
        return 'COMPLETE';
      case MatterInvoiceStatus.pending:
      case MatterInvoiceStatus.mandate_active:
      case MatterInvoiceStatus.mandate_submitted:
        return 'PENDING';
      case MatterInvoiceStatus.cancelled:
      case MatterInvoiceStatus.error:
      case MatterInvoiceStatus.failed:
        return 'FAILED';
      default:
        return 'UNKNOWN';
    }
  }

  getPaymentLinkText(matterInvoiceStatus: MatterInvoiceStatus): string {
    switch (matterInvoiceStatus) {
      case MatterInvoiceStatus.mandate_active:
      case MatterInvoiceStatus.mandate_submitted:
        return 'View Authorisation';
      case MatterInvoiceStatus.pending:
        return 'Authorise Payment';
      case MatterInvoiceStatus.complete:
        return 'View Receipt';
      default:
        return 'Contact Lawyer';
    }
  }
  paymentHasError(matterInvoiceStatus: MatterInvoiceStatus): boolean {
    switch (matterInvoiceStatus) {
      case MatterInvoiceStatus.complete:
      case MatterInvoiceStatus.pending:
      case MatterInvoiceStatus.mandate_active:
      case MatterInvoiceStatus.mandate_submitted:
        return false;
      default:
        return true;
    }
  }
}
